import { Avatar, Box, Chip, Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DropdownSelect from "components/DropdownSelect";
import LoadingButton from "components/LoadingButton";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import Dialog from "components/NoScrollDialog";
import { useLanguage } from "contexts/language.context";
import * as React from "react";
import accountsService from "services/accounts-service";
import useObjectState from "utils/useObjectState";

export default function UserGroupsEditNewDialog({
  isOpen,
  onSubmit,
  data,
  type,
  accountId,
  branchGroups,
}) {
  const { label } = useLanguage();
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [userGroup, setUserGroup] = React.useState({
    name: "",
  });

  const [options, changeOptions] = useObjectState({
    accounts: null,
  });

  React.useEffect(() => {
    if (!isOpen) return;
    setOpen(true);
    setLoading(false);
    if (!data)
      setUserGroup({
        name: "",
        // branchGroups: branchGroups || [],
      });
  }, [isOpen]);

  React.useEffect(() => {
    setUserGroup({ ...data });
  }, [data]);

  const handleGetAccounts = async () => {
    const [response, data] = await accountsService.getAccounts({ raw: true });
    if (response.ok) {
      changeOptions("accounts", data);
    } else {
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const dropdownOptions = React.useMemo(() => {
    return {
      accounts:
        options.accounts?.map((account) => ({
          id: account.id,
          label: account.name,
        })) || [],
    };
  }, [options]);

  React.useEffect(() => {
    handleGetAccounts();
  }, []);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: "form",
        onSubmit: async (event) => {
          event.preventDefault();

          setLoading(true);
          const result = await onSubmit({
            ...userGroup,
            // branchGroups: userGroup.branchGroups.map((b) => ({
            //   id: b.id,
            //   internal: b.internal,
            //   external: b.external,
            // })),
          });
          if (result.success) {
            handleClose();
          }

          setLoading(false);
        },
      }}
    >
      <DialogTitle>
        {type == "edit" ? label("edit-user-group") : label("create-user-group")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1} sx={{ mt: -0.5 }}>
          <Grid item xs={12}>
            <MDInput
              autoFocus
              required
              margin="dense"
              id="name"
              name="name"
              label={label("name-singular")}
              type="text"
              value={userGroup.name}
              onChange={(e) => {
                setUserGroup({
                  ...userGroup,
                  name: e.target.value,
                });
              }}
              fullWidth
            />
          </Grid>

          {!accountId && (
            <Grid item xs={12}>
              <DropdownSelect
                required
                label={label("account-singular")}
                initialValue={userGroup.accountId}
                onChange={(e) => {
                  setUserGroup({ ...userGroup, accountId: e?.id });
                }}
                items={dropdownOptions.accounts}
                fullWidth
                renderOption={(option) => (
                  <MDBox
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: 1,
                      alignItems: "center",
                    }}
                  >
                    <Avatar
                      sx={{ height: "30px", width: "30px" }}
                      src={option.url}
                    />
                    <MDTypography variant="body" sx={{ fontWeight: "400" }}>
                      {option.label}
                    </MDTypography>
                  </MDBox>
                )}
              />
            </Grid>
          )}

          {/* <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 0.5,

              pl: 1,
              py: 2,
            }}
          >
            <Typography
              sx={{
                fontSize: "1rem",
                fontWeight: "500",
                borderBottom: "1px solid",
                borderColor: "divider",
                pb: 0.5,
              }}
            >
              {label("branch-group-plural")}
            </Typography>
            {userGroup?.branchGroups?.length ? (
              userGroup?.branchGroups?.map((branchGroup) => {
                return (
                  <Box
                    key={"BB: " + branchGroup.id}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 1,
                      borderBottom: "1px solid",
                      borderColor: "divider",
                      pb: 0.5,
                    }}
                  >
                    <Typography sx={{ fontSize: "14px" }}>
                      {branchGroup?.name}
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Chip
                        color={branchGroup.internal ? "info" : "default"}
                        sx={(theme) => ({
                          color: branchGroup.internal
                            ? "white !important"
                            : theme.palette.info.contrastText,
                        })}
                        onClick={() => {
                          setUserGroup((userGroup) => {
                            return {
                              ...userGroup,
                              branchGroups: userGroup.branchGroups.map((bg) => {
                                if (bg.id == branchGroup.id) {
                                  return { ...bg, internal: !bg.internal };
                                }
                                return bg;
                              }),
                            };
                          });
                        }}
                        clickable
                        label={label("internal")}
                        size="small"
                      />
                      <Chip
                        sx={(theme) => ({
                          color: branchGroup.external
                            ? "white !important"
                            : theme.palette.info.contrastText,
                        })}
                        onClick={() => {
                          setUserGroup((userGroup) => {
                            return {
                              ...userGroup,
                              branchGroups: userGroup.branchGroups.map((bg) => {
                                if (bg.id == branchGroup.id) {
                                  return { ...bg, external: !bg.external };
                                }
                                return bg;
                              }),
                            };
                          });
                        }}
                        color={branchGroup.external ? "info" : "default"}
                        clickable
                        label={label("external")}
                        size="small"
                      />
                    </Box>
                  </Box>
                );
              })
            ) : (
              <Typography sx={{ fontSize: "14px" }}>
                There are no branch groups
              </Typography>
            )}
          </Box> */}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{label("cancel-button")}</Button>
        <LoadingButton
          loading={loading}
          type="submit"
          variant="gradient"
          color="info"
        >
          {type == "edit" ? label("save-button") : label("create-button")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
